import { createSlice } from "@reduxjs/toolkit";
import { userApi } from "./userApi";

const initialState = {
  users: null,
  userShow: null,
  count: null,
  userRoles: null,
  grantId: null,
};
const userSlice = createSlice({
  name: "userSlice",
  initialState,
  reducers: {
    unsetUserRoles(state) {
      state.userRoles = null;
    },
    cleanUpUser(state) {
      state.userShow = null;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      userApi.endpoints.getUsers.matchFulfilled,
      (state, action) => {
        state.users = action.payload.data;
        state.count = action.payload.meta.count;
      }
    );
    builder.addMatcher(
      userApi.endpoints.getUserShow.matchFulfilled,
      (state, action) => {
        state.userShow = action.payload.data;
      }
    );
    builder.addMatcher(
      userApi.endpoints.getGrant.matchFulfilled,
      (state, action) => {
        debugger;
        state.userRoles = action.payload.data[0].attributes.role_keys;
        state.grantId = action.payload.data[0].id;
      }
    );
  },
});
export const { unsetUserRoles, cleanUpUser } = userSlice.actions;
export default userSlice.reducer;
